import { useState, useEffect } from "react";

export const useSpeech = () => {
  const [speechRate, setSpeechRateState] = useState(() => {
    const storedRate = localStorage.getItem("speechRate");
    return storedRate ? parseFloat(storedRate) : 0.7;
  });

  useEffect(() => {
    localStorage.setItem("speechRate", speechRate);
  }, [speechRate]);

  const setRate = (rate) => {
    setSpeechRateState(rate);
  };

  const speakWord = (word) => {
    const utterance = new SpeechSynthesisUtterance(word);
    utterance.lang = "en-US";
    utterance.rate = speechRate;
    speechSynthesis.speak(utterance);
  };

  return { speechRate, setSpeechRate: setRate, speakWord };
};
